export const STONE_KING_ARENA_IMAGE =
  '/assets/bosses/stone-king-arena.jpg';

const WEEKLY_BOSS_SLUGS = new Set([
  'stone-king',
  'frost-empress',
  'storm-roc',
  'abyss-kraken',
  'verdant-colossus',
  'inferno-wyrm',
  'eclipse-sovereign',
]);

export function bossArenaImage(
  imageUrl: string | null,
  slug?: string,
): string | null {
  return (slug != null && WEEKLY_BOSS_SLUGS.has(slug))
    || imageUrl?.includes('/stone-king.png')
    ? STONE_KING_ARENA_IMAGE
    : null;
}
